import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ApplicationLevelAlertLevel } from '@mysvg/utils';

import { UpdateAppWorkerService } from '../update-app-worker.service';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'svg-frontends-update-app-worker-application-alert',
	styleUrls: ['./update-app-worker-application-alert.component.scss'],
	templateUrl: './update-app-worker-application-alert.component.html',
	standalone: false,
})
export class UpdateAppWorkerApplicationAlertComponent implements OnInit {
	private updateAppWorkerService = inject(UpdateAppWorkerService);
	@Input() isMyAsi: boolean = false;

	ALERT_LEVEL = ApplicationLevelAlertLevel.INFO;
	isNewVersionReady$: Observable<boolean>;

	ngOnInit(): void {
		this.isNewVersionReady$ = this.updateAppWorkerService.getVersionReadyForReload();
	}

	reload() {
		this.updateAppWorkerService.reloadAndReset(this.isMyAsi);
	}
}
